<template>
  <div>
    <Button
      class="btn btn-circle btn-circle-sm btn-outline-color2 d-inline-block hover-color-white open-block-menu"
      @click="isOpen = !isOpen"
    >
      <i class="fa fa-plus"></i>
    </Button>
    <div class="menu-blocks" :class="{
      'is-active': isOpen
    }">
      <div class="menu">
        <div
          class="block-select text-left"
          v-closable="{
            exclude: ['open-block-menu'],
            shouldCheck: isOpen,
            handler: 'hide'
          }"
        >
          <div class="d-flex flex-wrap w-100">
            <!-- PARAGRAPH -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="paragraph"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-paragraph" />
              </span>
              <span class="d-block font-size-xSmall desc">
                Parágrafo
              </span>
            </button> <!-- END PARAGRAPH -->
            <!-- HEADER -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="heading"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-header"/>
              </span>
              <span class="d-block font-size-xSmall desc">
                Cabeçalho
              </span>
            </button> <!-- END HEADER -->
            <!-- HEADER -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="subheading"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-header" style="font-size: 12px;" />
              </span>
              <span class="d-block font-size-xSmall desc">
                Sub-título
              </span>
            </button> <!-- END HEADER -->
            <!-- LIST -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="bulletList"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-list-ul" />
              </span>
              <span class="d-block font-size-xSmall desc">
                Lista
              </span>
            </button> <!-- END LIST -->
            <!-- IMAGE -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="showImageUpload()"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-image" />
              </span>
              <span class="d-block font-size-xSmall desc">
                Imagem
              </span>
            </button> <!-- END IMAGE -->
            <!-- HR -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="horizontalRule"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-minus-square" />
              </span>
              <span class="d-block font-size-xSmall desc">
                Separador
              </span>
            </button> <!-- END HR -->
            <!-- QUOTE -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="blockquote"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-quote-right" />
              </span>
              <span class="d-block font-size-xSmall desc">
                Citação
              </span>
            </button> <!-- END QUOTE -->
            <!-- CODE -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="code_block"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-code" />
              </span>
              <span class="d-block font-size-xSmall desc">
                Código
              </span>
            </button> <!-- END CODE -->
            <!-- CODE -->
            <button
              class="menubar__button background-white rounded-default px-3 py-2 text-center shadow-light"
              @click="openYoutubeModal"
            >
              <span class="d-block text-color2 image">
                <i class="fa fa-youtube-play" />
              </span>
              <span class="d-block font-size-xSmall desc">
                YouTube
              </span>
            </button> <!-- END CODE -->
          </div>

          <input
            type="file"
            style="display: none;"
            @change="handleFile"
            accept="image/*"
            ref="fileInput"
          />
        </div>
      </div>
    </div>

    <!-- YOUTUBE MODAL -->
    <YoutubeModal
      @confirmed="youtube"
    /> <!-- END YOUTUBE MODAL -->
  </div>
</template>

<script>

// import { FloatingMenu } from '@tiptap/vue-2'
import { uploadImage } from '@/utils'

import YoutubeModal from '@/components/common/Editor/Modals/YoutubeModal'

export default {
  name: 'MenuBlocks',
  props: ['editor'],
  components: {
    YoutubeModal
    // FloatingMenu
  },
  data () {
    return {
      blockSelect: false,
      imageCommand: null,
      isOpen: false
    }
  },
  methods: {
    paragraph () {
      this.editor.chain().focus().setParagraph().run()
      this.hide()
    },
    heading () {
      this.editor.chain().focus().setHeading({ level: 2 }).run()
      this.hide()
    },
    subheading () {
      this.editor.chain().focus().setHeading({ level: 3 }).run()
      this.hide()
    },
    blockquote () {
      this.editor.chain().focus().setBlockquote().run()
      this.hide()
    },
    bulletList () {
      this.editor.chain().focus().toggleBulletList().run()
      this.hide()
    },
    code_block () {
      this.editor.chain().focus().toggleCodeBlock().run()
      this.hide()
    },
    showImageUpload () {
      this.$refs.fileInput.click()
    },
    horizontalRule () {
      this.editor.chain().focus().setHorizontalRule().run()
      this.hide()
    },
    openYoutubeModal () {
      this.$bvModal.show('youtube-insert-modal')
    },
    youtube (src) {
      console.log(src)
      this.editor.chain().focus().setYoutube({ src: src }).run()
    },
    async handleFile (e) {
      try {
        const file = e.target.files[0]
        const image = await uploadImage(file)
        const src = image.src
        this.editor.chain().focus().setImage({ src }).run()
        this.paragraph()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.imageCommand = null
      this.hide()
    },
    hide () {
      this.isOpen = false
      // this.$emit('block-clicked')
    }
  }
}
</script>

<style lang="scss" scoped>

.menu-blocks {
  position: absolute;
  z-index: 1;
  margin-top: -0.25rem;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;
  right: 0;
  text-align: right;
  &.is-active {
    opacity: 1;
    visibility: visible;

    .menu {
      display: block;
    }
  }

  .menu {
    display: none;
  }

  .block-select {
    width: 280px;
    margin-top: 15px;
  }

  .menubar__button {
    background: #fff;
    border: none;
    width: 90px;
    margin-right: 5px;
    margin-bottom: 5px;

    &:nth-of-type(3n) {
      margin-right: 0;
    }

    .image {
      height: 27px;
    }
    .desc {
      white-space: nowrap;
    }
  }
}
</style>
